import { Component } from '@angular/core';
import { ProvisionsListComponent } from './provisions-list/provisions-list.component';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'app-provisions',
  standalone: true,
  imports: [ProvisionsListComponent, NzGridModule, NzSpinModule],
  templateUrl: './provisions.component.html',
  styleUrl: './provisions.component.scss',
})
export class ProvisionsComponent {}
